import { State, US_STATES, CA_PROVINCES } from "@/shared/utils/constants";

// US states and CA provinces stay as separate catalogs. A code from either normalizes — their
// codes don't collide — because CA breeds are province-scoped on spot-api (Orca
// /quote/v1/breeds/{species}/state/{province}), so provinces must pass through the funnel rather
// than being stripped to `undefined` the way they were when spot-api discarded the CA stateCode.
const usStateCodes = new Set(US_STATES.map(s => s.value.toUpperCase()));
const caProvinceCodes = new Set(CA_PROVINCES.map(s => s.value.toUpperCase()));

const codeToName = new Map<string, string>();
const lowerNameToLabel = new Map<string, string>();
const registerNames = (s: State) => {
    codeToName.set(s.value.toUpperCase(), s.label);
    lowerNameToLabel.set(s.label.toLowerCase(), s.label);
};
US_STATES.forEach(registerNames);
CA_PROVINCES.forEach(registerNames);

type RatingStateSource = { ratingAddress?: { state?: string | null } | null } | null | undefined;

export const StateUtils = {
    getStateName(code?: string | null): string | undefined {
        if (!code) return undefined;
        const trimmed = code.trim();
        return codeToName.get(trimmed.toUpperCase()) ?? lowerNameToLabel.get(trimmed.toLowerCase());
    },

    /** Trim → uppercase → must be a US state or CA province code, else undefined. The single normalization funnel. */
    normalizeStateCode(code?: string | null): string | undefined {
        if (!code) return undefined;
        const upper = code.trim().toUpperCase();
        return usStateCodes.has(upper) || caProvinceCodes.has(upper) ? upper : undefined;
    },

    /** First source whose ratingAddress.state normalizes wins. Zip-only sources are skipped. */
    resolveRatingState(...sources: RatingStateSource[]): string | undefined {
        for (const source of sources) {
            const normalized = StateUtils.normalizeStateCode(source?.ratingAddress?.state);
            if (normalized) return normalized;
        }
        return undefined;
    }
};
